// Real data for White Valley Cafe Landing Page

export const restaurantInfo = {
  name: "White Valley Cafe & Multicuisine Restaurant",
  tagline: "White Valley Cafe & Multicuisine Restaurant",
  description: "Welcome to White Valley Cafe, Rajkot's premier poolside multi-cuisine restaurant. Since opening our doors, we've been dedicated to creating an exceptional vegetarian dining destination where culinary artistry meets tranquil ambiance. Our chefs blend Italian, Continental, and North Indian flavors to craft dishes that delight every palate.",
  priceRange: "₹400–600 per person",
  types: [
    "Vegetarian Restaurant",
    "Cafe",
    "Banquet Hall",
    "Italian Restaurant",
    "Fast Food Restaurant",
    "Continental Restaurant",
    "North Indian Restaurant"
  ],
  serviceOptions: [
    "All you can eat",
    "Outdoor seating",
    "Private dining room"
  ]
};

export const contactInfo = {
  phone: "081417 07107",
  phoneLink: "tel:+918141707107",
  whatsapp: "+918141707107",
  address: {
    street: "Dharamshi Korat Rd",
    landmark: "Opposite Knockout Game Zone",
    area: "Mota Mava",
    city: "Rajkot",
    state: "Gujarat",
    pincode: "360005",
    full: "Dharamshi Korat Rd, opposite Knockout Game Zone, Mota Mava, Rajkot, Gujarat 360005"
  },
  mapLink: "https://maps.app.goo.gl/Wb92feNwZmEXhCzj7",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3600.7407883495343!2d70.74940977509188!3d22.274904243815893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959cb0019a30691%3A0xb9e627feb3585dca!2sWhite%20Valley%20Cafe%20%26%20Multi-cuisine%20Restaurant!5e1!3m2!1sen!2sin!4v1768755819764!5m2!1sen!2sin",
  reviewLink: "https://g.page/r/CcpdWLP-J-a5EBE/review",
  zomatoLink: "https://www.zomato.com/rajkot/white-valley-mota-mava/order"
};

export const hours = {
  schedule: [
    { day: "Sunday", hours: "10 am – 1 am" },
    { day: "Monday", hours: "10 am – 1 am" },
    { day: "Tuesday", hours: "10 am – 1 am" },
    { day: "Wednesday", hours: "10 am – 1 am" },
    { day: "Thursday", hours: "10 am – 1 am" },
    { day: "Friday", hours: "10 am – 1 am" },
    { day: "Saturday", hours: "10 am – 1 am" }
  ],
  summary: "Open daily 10 am – 1 am"
};

export const heroData = {
  headline: "An Urban Sanctuary for Your Senses",
  subheadline: "Where Italian, Continental, and North Indian flavors meet poolside elegance in Rajkot",
  cta: "Explore the Experience",
  backgroundImage: "/images/gallery-1.webp"
};

export const identityData = {
  title: "Why White Valley Exists",
  narrative: "From romantic candlelit dinners to joyful family celebrations, White Valley has hosted countless memorable moments. Our commitment to quality ingredients, innovative vegetarian recipes, and warm hospitality has made us a beloved gathering place in the heart of Rajkot. Experience the magic of dining under the stars, where every meal becomes a cherished memory.",
  pillars: [
    { label: "Poolside Dining", description: "Serene outdoor seating by the water" },
    { label: "Multi-Cuisine", description: "Italian, Continental & North Indian flavors" },
    { label: "Private Events", description: "Banquet hall for special celebrations" }
  ]
};

export const galleryImages = [
  {
    src: "/images/gallery-1.webp",
    caption: "Evenings that slow time"
  },
  {
    src: "/images/gallery-2.webp",
    caption: "Designed for long conversations"
  },
  {
    src: "/images/gallery-3.webp",
    caption: "Where warmth meets elegance"
  },
  {
    src: "/images/gallery-4.webp",
    caption: "Your private urban escape"
  },
  {
    src: "/images/gallery-5.webp",
    caption: "Culinary excellence at White Valley"
  },
  {
    src: "/images/gallery-6.webp",
    caption: "Artisanal beverages"
  },
  {
    src: "/images/gallery-7.webp",
    caption: "Handcrafted with love"
  },
  {
    src: "/images/gallery-8.webp",
    caption: "Perfect pairings"
  },
  {
    src: "/images/gallery-9.webp",
    caption: "Refreshing delights"
  },
  {
    src: "/images/gallery-10.webp",
    caption: "Moments to cherish"
  }
];

export const culinaryData = {
  title: "Our Menu",
  description: "A vegetarian paradise with cuisines from around the world. ₹400–600 per person.",
  categories: [
    {
      name: "Soups",
      items: ["Hot & Sour Soup", "Chef Special Soup", "Khowsuey Soup", "Manchurian Soup", "Mexican Tortilla Soup", "Sweet Corn Soup", "Lemon Coriander Soup", "Broccoli Almond Soup"]
    },
    {
      name: "Starters",
      items: ["Tandoori Platter", "Manchurian Dry", "Paneer 65", "Cheese Ball", "Italian Cottage Roll", "Afghani Paneer Tikka", "Cheese Cigar Roll", "Dragon Potato", "Hara Bhara Kabab", "Kung Pao Paneer", "Mexican Cigar Roll", "Pahadi Paneer Tikka", "Paneer Tikka Dry", "Spinach Cottage Roll", "Veg Crispy", "Veg Spring Roll"]
    },
    {
      name: "Main Course",
      items: ["Veg Handi", "Veg Makhanwala", "Veg Kadai", "Veg Toofani", "Paneer Butter Masala", "Paneer Angoori", "Paneer Bhurji", "Paneer Lababdar", "Dal Tadka", "Dal Makhani"]
    },
    {
      name: "Rice & Noodles",
      items: ["Hyderabadi Biryani", "Mexican Hot Pot Rice", "Manchurian Fried Rice", "Schezwan Fried Rice", "Veg Fried Rice", "Jeera Rice", "Veg Hakka Noodles", "Schezwan Noodles", "Veg Singapore Noodles"]
    },
    {
      name: "Pizza",
      items: ["Margherita Pizza", "Paneer Chilli Pizza", "Mexican Pizza", "Veg Delight Pizza", "Italiano Pizza", "Tandoori Paneer Pizza"]
    },
    {
      name: "Pasta",
      items: ["Arrabiata Pasta", "Alfredo Pasta", "Penne With Cheesy Tomato Sauce", "Spaghetti Aglio E Olio", "Spinach Hazelnut Ravioli"]
    },
    {
      name: "Sandwiches & Burgers",
      items: ["Avocado Toast", "Veg Cheese Sandwich", "4 Cheese Sandwich", "Mexican Sandwich", "Cheese Chilli Sandwich", "Nutella Cheese Sandwich", "Club Sandwich", "Veg Cheese Burger", "Aloo Tikki Burger", "Double Cheese Burger"]
    },
    {
      name: "South Indian",
      items: ["Masala Dosa", "Onion Uttapam", "Cheese Mysore Masala Dosa", "Rava Masala Dosa", "Fry Cheese Dosa"]
    },
    {
      name: "Quick Bites",
      items: ["Loaded Fries", "French Fries", "Peri Peri Fries", "Monaco Toppings", "Bhel"]
    },
    {
      name: "Sizzlers",
      items: ["Paneer Shashlik Sizzler", "Classic Veg Sizzler", "Mexican Sizzler", "Chef Special Sizzler"]
    },
    {
      name: "Beverages",
      items: ["Cold Coffee", "Hot Coffee & Teas", "Lemon Mint Cooler", "Fruit Punch", "Green Apple Mocktail", "Strawberry Punch", "Oreo Shake", "Ferrero Nutella Shake", "Lotus Biscoff Shake", "Soda Floats"]
    },
    {
      name: "Maggie",
      items: ["Tadka Maggie", "Cheese Maggie", "Veggie Maggie", "Butter Masala Maggie"]
    },
    {
      name: "Breads",
      items: ["Butter Kulcha", "Butter Paratha", "Garlic Naan", "Lachha Paratha", "Missi Roti", "Cheese Garlic Naan"]
    },
    {
      name: "Desserts",
      items: ["American Nuts Scoop", "Chocolate Scoop", "Gulab Jamun", "Sizzling Brownie"]
    }
  ]
};

export const signatureData = {
  title: "The Poolside Experience",
  description: "Nestled by the poolside, White Valley combines a serene ambiance with exceptional service. Watch the water shimmer under evening lights while enjoying your meal. Whether it's a casual outing, romantic dinner, or special celebration, our outdoor seating creates unforgettable moments.",
  highlights: [
    "All you can eat dining option",
    "Outdoor poolside seating",
    "Private dining rooms available"
  ],
  image: "/images/gallery-2.webp"
};

export const testimonials = [
  {
    quote: "Beat food quality and quantity. Peaceful atmosphere. Service also good.",
    author: "HARDIK PATEL",
    platform: "Google Review"
  },
  {
    quote: "Friendly staff, clean and cozy rooms, and the food was absolutely delicious.",
    author: "Dhara Sapovadiya",
    platform: "Google Review"
  },
  {
    quote: "Awesome food and staff response is so good and service is awesome.",
    author: "Chintan Bhatti",
    platform: "Google Review"
  }
];

export const eventsData = {
  title: "More Than Dining",
  description: "White Valley is the perfect venue for every occasion. From intimate dinners to grand celebrations, our spaces transform to match your vision.",
  events: [
    {
      name: "Private Dining",
      description: "Exclusive rooms for intimate gatherings",
      icon: "door-closed"
    },
    {
      name: "Banquet Hall",
      description: "Grand celebrations and corporate events",
      icon: "party-popper"
    },
    {
      name: "Birthday Parties",
      description: "Make your special day memorable",
      icon: "cake"
    },
    {
      name: "Anniversary Dinners",
      description: "Romantic poolside celebrations",
      icon: "heart"
    }
  ],
  image: "/images/gallery-3.webp"
};

export const accessibilityData = {
  title: "Designed for Everyone",
  features: [
    "All you can eat option available",
    "Outdoor poolside seating",
    "Private dining rooms",
    "Vegetarian-friendly menu",
    "Family-friendly atmosphere"
  ]
};

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Menu", href: "/menu" },
  { label: "Gallery", href: "/gallery" },
  { label: "Events", href: "/events" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" }
];
